import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconEyeCrossed16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="hide">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.62616 8.10056C5.62616 9.20513 6.52159 10.1006 7.62616 10.1006C8.73073 10.1006 9.62616 9.20513 9.62616 8.10056C9.62616 6.99599 8.73073 6.10056 7.62616 6.10056C6.52159 6.10056 5.62616 6.99599 5.62616 8.10056Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.37384 8.18132L3.88911 9.886C5.87807 12.1236 9.37425 12.1236 11.3632 9.886L12.8785 8.18132L11.1617 6.46454C9.20907 4.51191 6.04325 4.51191 4.09063 6.46453L2.37384 8.18132ZM12.5759 5.05032L14.9594 7.43384C15.3338 7.80824 15.3515 8.40957 14.9997 8.80531L12.858 11.2147C10.0735 14.3473 5.17883 14.3473 2.3943 11.2147L0.252593 8.80531C-0.0991718 8.40957 -0.081501 7.80824 0.292895 7.43384L2.67642 5.05032C5.41008 2.31665 9.84224 2.31665 12.5759 5.05032Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.2929 15.7072L0.292907 1.70718L1.70712 0.292969L15.7071 14.293L14.2929 15.7072Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
